// extracted by mini-css-extract-plugin
export var button = "bT_p7";
export var button__darkBlue = "bT_qc";
export var button__edgesGrey = "bT_qd";
export var button__edgesRed = "bT_p9";
export var button__loader = "bT_qf";
export var button__red = "bT_p8";
export var button__transparent = "bT_qb";
export var loadingSpinner = "bT_qg";